const ALLOWED_FORMATS = ['jpeg', 'png', 'webp']

export const optimizeImageUrl = (src, options = {}) => {
  if (!src) {
    return ''
  }

  const { IMAGE_CDN } = process.env

  let imageUrl = src

  if (!IMAGE_CDN) {
    return imageUrl
  }

  const urlPrefix = IMAGE_CDN.replace(/\/$/, '')

  const parts = []

  if (options.keepType) {
    parts.push('keepType')
  }

  if (options.width) {
    parts.push(`w${options.width}`)
  }

  if (options.height) {
    parts.push(`h${options.height}`)
  }

  if (options.quality) {
    parts.push(`q${options.quality}`)
  }

  if (options.format && ALLOWED_FORMATS.includes(options.format)) {
    imageUrl += `.${options.format}`
  }

  const optionsPrefix = parts.length ? `/${parts.join('/')}` : ''

  const uri = new URL(imageUrl)

  return `${urlPrefix}${optionsPrefix}${uri.pathname}`
}
